import clsx from 'clsx';
import { useNavigate } from 'react-router';
import { useAuth } from '../../../lib/auth';
import AuthLayout from '../../layouts/AuthLayout';
import Skeleton from '../../../components/Skeleton';
import { PlanResults } from '../../../components/plan/PlanResults';
import { PlanTabs } from '../../../components/plan/PlanTabs';
import { usePlan } from '../../../lib/plan/usePlan';

export default function PlanResultsPage() {
    useAuth({
        middleware: 'auth',
        redirectTo: '/',
        tmp: 'PlanResultsPage',
    });

    const navigate = useNavigate();
    const { plan, isLoading } = usePlan();

    if (isLoading) {
        return (
            <AuthLayout>
                <main
                    className={clsx(
                        'relative',
                        'mx-auto box-content max-w-2xl py-9',
                        'px-4 sm:px-8 md:px-10'
                    )}
                >
                    <Skeleton className="mb-6 h-64 w-full rounded-2xl" />
                    <Skeleton className="h-40 w-full rounded-2xl" />
                </main>
            </AuthLayout>
        );
    }

    if (plan === null) {
        navigate('/plan-na-miru/dotaznik');
        return null;
    }

    return (
        <AuthLayout>
            <main
                className={clsx(
                    'relative',
                    'mx-auto box-content max-w-3xl py-9',
                    'px-4 sm:px-8 md:px-10'
                )}
            >
                <h1 className="mb-6">Plán na míru</h1>
                <div className="mb-10">
                    <PlanTabs />
                </div>
                <PlanResults plan={plan} />
            </main>
        </AuthLayout>
    );
}
